import React, { useEffect, useState } from 'react';
import { useContextData } from '../../../core/context';
import Config from '../../../core/config';
import { makeRequestWithErrorMessage } from '../../../core/services/v1/request';
import { toast } from '../../../core/lib/toastAlert';
import { formatDateV2 } from '../../../core/helper/date-format';
const ActivatedBox = () => {
    const [plans, setPlans] = useState([]);
    const [activePlans, setActivePlans] = useState('1');
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const { myProfile, setUserProfile } = useContextData();
    const claimReferral = async () => {
        setLoading3(() => true)
        const params = {
            url: `${Config.V1_API_URL}stake-trade/claim-referral`,
            method: 'POST',
            headers: {
                'Content-Type': 'Application/json',
            },
        }
        const res = await makeRequestWithErrorMessage(params)
        if (res.status) {
            setUserProfile();
            toast({ type: 'success', message: res.message })
            setLoading3(() => false);
        }
        else {
            toast({ type: 'error', message: res.message })
            setLoading3(() => false);
        }
        setLoading3(() => false);

    }
    const allData = [
        {
            title: 'Total Investment', id: 1, desc: `$${myProfile?.totalInvestment || 0}`
        },
        {
            title: <span className='d-flex justify-content-between align-items-center w-100'><span style={{ opacity: 0.75 }}>Referral Bonus</span> <div className='form-inputs'>
                <button type='button' onClick={() => { claimReferral() }} className='btn-theme-color' style={{ width: 'fit-content', padding: '0px 12px', height: '30px' }} disabled={!myProfile?.referralBonus || myProfile?.referralBonus == 0 || loading3}>{loading3 ? '...Loading' : 'Claim'}</button>
            </div></span>, id: 2, desc: `$${myProfile?.referralBonus || 0}`
        },
        { title: 'Eligible Claim', id: 3, desc: (`$${myProfile?.totalEligibleClaim}` || `$0.0`) },
        { title: 'Withdraw Amount', id: 4, desc: `$${myProfile?.totalEligible || 0.0}` },
    ]
    useEffect(() => {
        setUserProfile();
    }, [])
    useEffect(() => {
        if (myProfile) {
            setPlans(() => {
                return myProfile?.stakes.filter(el => el?.name === '1') || []
            })
            setActivePlans(() => '1')
        }
    }, [myProfile])
    const withdrawEasy = async (id = '0') => {
        setLoading(() => true)
        const params = {
            url: `${Config.V1_API_URL}stake-trade/withdraw-stake/${id}`,
            method: 'POST',
            headers: {
                'Content-Type': 'Application/json',
            },
        }
        const res = await makeRequestWithErrorMessage(params)
        if (res.status) {
            setUserProfile();
            toast({ type: 'success', message: res.message })
            setLoading(() => false);
        }
        else {
            toast({ type: 'error', message: res.message })
            setLoading(() => false);
        }
        setLoading(() => false);

    }
    const claimMonthly = async (id = '0') => {
        setLoading2(() => true)
        const params = {
            url: `${Config.V1_API_URL}stake-trade/claim-stake/${id}`,
            method: 'POST',
            headers: {
                'Content-Type': 'Application/json',
            },
        }
        const res = await makeRequestWithErrorMessage(params)
        if (res.status) {
            setUserProfile();
            toast({ type: 'success', message: res.message })
            setLoading2(() => false);
        }
        else {
            toast({ type: 'error', message: res.message })
            setLoading2(() => false);
        }
        setLoading2(() => false);

    }

    const calculateDaysLeft = (createdAt, tier) => {
        const createdDate = new Date(createdAt);
        const now = new Date();

        const diffInMinutes = (now - createdDate) / (1000 * 60);
        const minutesLeft = tier - diffInMinutes;

        const daysLeft = Math.max(0, Math.floor(minutesLeft / 1440));

        return daysLeft;
    };

    return (
        <div>
            <div className='d-flex justify-content-between align-items-center flex-column flex-md-row' style={{ gap: '20px' }}>
                {
                    allData.map((data, index) => {
                        const { title = '', desc = '', id = 0 } = data
                        return (
                            <div className='dHomeUpperCard common-transition' id={index}>
                                <h5 className='w-100' style={{ opacity: id === 2 ? 1 : 0.75 }}>{title}</h5>
                                <p>{desc}</p>
                            </div>
                        );
                    })
                }
            </div>
            <div className='mt-4'>
                <div className='d-flex justify-content-center align-items-center' style={{ gap: '10px', marginBottom: '-15px' }}>
                    <button type='button' onClick={() => {
                        setPlans(() => {
                            return myProfile?.stakes.filter(el => el?.name === '1') || []
                        })
                        setActivePlans(() => '1')
                    }} className={`btn-theme-color ${activePlans === '1' ? '' : 'btn-theme-color-inactive'} px-4 py-2 fw-bold`}>Plan 1</button>
                    <button type='button' onClick={() => {
                        setPlans(() => {
                            return myProfile?.stakes.filter(el => el?.name === '2') || []
                        })
                        setActivePlans(() => '2')
                    }} className={`btn-theme-color ${activePlans === '2' ? '' : 'btn-theme-color-inactive'} px-4 py-2 fw-bold`}>Plan 2</button>
                </div>
                {!plans || plans.length == 0 ? <div style={{ marginTop: '30px' }}><p className='text-center'>No Data!</p></div> :
                    plans.map((el, index) => <div className='manageTable' key={index}>
                        <div className='gridding mx-auto text-center px-3'>
                            <div class="itemGrid">
                                <p className='py-2 mb-0 fw-bold'>Date</p>
                                <p className='py-2 mb-0'>{formatDateV2(el?.createdAt) || 0}</p>
                            </div>
                            <div class="itemGrid">
                                <p className='py-2 mb-0 fw-bold'>Name</p>
                                <p className='py-2 mb-0'>Plan {el?.name}</p>
                            </div>
                            <div class="itemGrid">
                                <p className='py-2 mb-0 fw-bold'>Amount</p>
                                <p className='py-2 mb-0'>{el?.amount} USDT</p>
                            </div>
                            <div class="itemGrid">
                                <p className='py-2 mb-0 fw-bold'>Lock In</p>
                                <p className='py-2 mb-0'>{el?.tier == 788400 ? '18 Months' : 1051200 ? '24 months' : ''}</p>
                            </div>
                            <div class="itemGrid">
                                <p className='py-2 mb-0 fw-bold'>Monthly %</p>
                                <p className='py-2 mb-0'>{el?.name === '1' ? 'NA' : '3%'}</p>
                            </div>
                            <div class="itemGrid">
                                <p className='py-2 mb-0 fw-bold'>Days Left</p>
                                <p className='py-2 mb-0'>{calculateDaysLeft(el?.createdAt, el?.tier)} Days</p>
                            </div>
                            <div class="itemGrid">
                                <p className='py-2 mb-0 fw-bold'>Total Claimable</p>
                                <p className='py-2 mb-0'>{el?.eligibleClaim + el?.eligibleWithdraw} USDT</p>
                            </div>
                            <div class="itemGrid">
                                <div className='d-flex justify-content-center align-items-center' style={{ gap: '5px' }}>
                                    {el?.name === '2' ? <button type='button' onClick={() => { claimMonthly(el?._id) }} className='px-3 py-2 btn-theme-color' disabled={!el?.eligibleClaim || el?.eligibleClaim == 0 || loading2}>{loading2 ? '...Loading' : '3% Claim'}</button> : null}
                                    <button type='button' onClick={() => { withdrawEasy(el?._id) }} className='px-3 py-2 btn-theme-color' disabled={!el?.isEligible || !el?.eligibleWithdraw || el?.eligibleWithdraw == 0 || loading}>{loading ? '...Loading' : (el?.withdrawStatus !== 3 && !el?.isEligible) ? 'Closed' : 'Withdraw'}</button>
                                </div>
                            </div>

                        </div>  </div>)
                }
                {/* <div className='col-12 col-lg-6'>
                    <div className='activated-stake p-3'>
                        <div className='d-flex justify-content-between align-items-center mt-1 mb-3'>
                            <div className='badge-sx-stake'>
                                <p style={{ opacity: 0.75 }}>Active</p>
                            </div>
                            <div>
                                <p style={{
                                    color: '#FFF',
                                    fontFamily: '"Poppins", sans-serif',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: 'normal',
                                }}>{yearmonthdateFormat(easy?.createdAt) || 0}</p>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between align-items-center pt-3'>
                            <div>
                                <p style={{
                                    color: '#FFF',
                                    fontFamily: '"Poppins", sans-serif',
                                    fontSize: '20px',
                                    fontStyle: 'normal',
                                    fontWeight: 600,
                                    lineHeight: 'normal',
                                }}>USDT PLAN</p>
                            </div>
                            <div>
                                <p style={{
                                    color: '#00FFA3',
                                    fontFamily: '"Poppins", sans-serif',
                                    fontSize: '24px',
                                    fontStyle: 'normal',
                                    fontWeight: 600,
                                    lineHeight: 'normal',
                                }}>₮ {easy?.amount || 0}</p>
                            </div>
                        </div>
                        <div className='pt-4'>
                            <ProgressBar
                                now={+progressEasy} label={`${progressEasy}%`} style={{ background: "#F9F7FF" }}
                            />
                        </div>
                        <div className='form-inputs pt-3'>
                        <button type='button' onClick={() => withdrawEasy(easy?._id)} className='btn-theme-color' style={{ width: 'fit-content', padding: '0px 20px', height: '35px', fontSize:'14px' }} disabled={loading || (!easy?.isEligible)}>{loading ? <><Spinner aria-label="Spinner button example" size="sm" />
                            <span className="ps-3">Loading...</span></> : 'Withdraw'}</button>
                    </div>
                    </div>
                </div> */}
            </div>

        </div>
    );
};

export default ActivatedBox;